import type { Folder } from "@hq/contracts";

export const TEMPLATES_FOLDER_NAME = "Templates";

/** The live folder named "Templates" (case-insensitive), if any. A convention, not a schema. */
export function templatesFolderId(folders: readonly Folder[]): string | undefined {
  return folders.find((f) => !f.deletedAt && f.name.trim().toLowerCase() === "templates")?.id;
}
